module.exports = __webpack_public_path__ + "media/assets/images/google_play_sm-eng-861e2cacb9d491a071426db0148b7c40.png";